function reducer(state = [], action) {  
  switch (action.type) {
    case 'FAMILY/PLANS/SET':
      return action.afp;    
    default:
      return state;
  }
}

export default reducer;
